var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    { attrs: { modalId: "fuel-monitor-features-modal", size: "modal-md" } },
    [
      _c(
        "ModalHeader",
        {
          style: { padding: "4px 12px" },
          attrs: {
            title: _vm.$t("xWhatAreTheFeatures"),
            icon: "far fa-circle-info colorOrange mr-1"
          }
        },
        [
          _c("div", { staticClass: "cols-auto" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-icon-button btn-icon-button--gray",
                attrs: { type: "button", "data-test-hook": "CloseModalBtn" },
                on: {
                  click: function($event) {
                    return _vm.closeFuelMonitorFeaturesModal()
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-times" })]
            )
          ])
        ]
      ),
      _c("ModalBody", [
        _c("div", { staticClass: "features" }, [
          _c("div", { staticClass: "premium" }, [
            _c("p", { staticClass: "mb-1" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.$t("xFeaturesIncludedInPremium")))
              ])
            ]),
            _c("div", { staticClass: "feature" }, [
              _c("i", { staticClass: "fa-regular fa-gas-pump" }),
              _c("div", { staticClass: "mb-2" }, [
                _c(
                  "p",
                  {
                    attrs: {
                      "data-test-hook":
                        "fuel-monitor-features-modal-step-1-fuel-monitor-feature-title"
                    }
                  },
                  [_c("strong", [_vm._v(_vm._s(_vm.$t("xCurrentFuelLevel")))])]
                ),
                _c(
                  "p",
                  {
                    staticClass: "supporting-text",
                    attrs: {
                      "data-test-hook":
                        "premium-enrollment-modal-step-1-fuel-monitor-feature-description"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xFuelLevelDescription")) + " ")]
                )
              ])
            ]),
            _c("div", { staticClass: "feature" }, [
              _c("i", { staticClass: "fa-regular fa-chart-line" }),
              _c("div", { staticClass: "mb-2" }, [
                _c(
                  "p",
                  {
                    attrs: {
                      "data-test-hook":
                        "fuel-monitor-features-modal-step-2-fuel-monitor-feature-title"
                    }
                  },
                  [_c("strong", [_vm._v(_vm._s(_vm.$t("xFuelUsageHistory")))])]
                ),
                _c(
                  "p",
                  {
                    staticClass: "supporting-text",
                    attrs: {
                      "data-test-hook":
                        "fuel-monitor-features-modal-step-2-fuel-monitor-feature-description"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xFuelUsageDescription")) + " ")]
                )
              ])
            ]),
            _c("div", { staticClass: "feature" }, [
              _c("i", { staticClass: "fa-regular fa-warning" }),
              _c("div", { staticClass: "mb-2" }, [
                _c(
                  "p",
                  {
                    attrs: {
                      "data-test-hook":
                        "fuel-monitor-features-modal-step-3-fuel-monitor-feature-title"
                    }
                  },
                  [_c("strong", [_vm._v(_vm._s(_vm.$t("xFuelLevelWarnings")))])]
                ),
                _c(
                  "p",
                  {
                    staticClass: "supporting-text",
                    attrs: {
                      "data-test-hook":
                        "fuel-monitor-features-modal-step-3-fuel-monitor-feature-description"
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("xFuelLevelWarningsDescription")) +
                        " "
                    )
                  ]
                )
              ])
            ]),
            _c("div", { staticClass: "feature" }, [
              _c("i", { staticClass: "fa-regular fa-battery-full" }),
              _c("div", { staticClass: "mb-2" }, [
                _c(
                  "p",
                  {
                    attrs: {
                      "data-test-hook":
                        "fuel-monitor-features-modal-step-4-fuel-monitor-feature-title"
                    }
                  },
                  [_c("strong", [_vm._v(_vm._s(_vm.$t("xBatteryLevel")))])]
                ),
                _c(
                  "p",
                  {
                    staticClass: "supporting-text",
                    attrs: {
                      "data-test-hook":
                        "fuel-monitor-features-modal-step-4-fuel-monitor-feature-description"
                    }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("xBatteryLevelDescription")) + " "
                    )
                  ]
                )
              ])
            ]),
            _c("p", [_vm._v(_vm._s(_vm.$t("xFuelMonitorsRequireAPlan")))])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }